export enum DropType {
	Purchase = 'purchase',
	Application = 'application',
	Redemption = 'redemption',
}
